import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip, FormGroup, Label, CustomInput} from 'reactstrap';
import { SketchPicker as ColorPicker } from 'react-color';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

import { FilePond, File, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop.js';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginImageCrop, FilePondPluginImageEdit);

import { WithContext as ReactTags } from 'react-tag-input';

import { Editor } from '@tinymce/tinymce-react'

import http from "../../../../services/HttpService";
import {Redirect} from "react-router";
import Route from "../../../../Routes";
import Loading from "../../../includes/Loading";
import swal from "sweetalert2";
import i18next from 'i18next';
import { Translation } from "react-i18next";

import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class AddTool extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        title: "",
        buttonName: "Try for Free",
        prisingButton: "",
        description:"",
        text:"",
        image: [],
        loading: false,
        updated: false,
        valid: {
            title: false,
            description:false,
            text: false,
            image: false,
            industry_value: false,
            specialization_value: false,
            keyword_value:false,
            tags:false,
            fea_tags:false,
            facebook:false,
            twitter:false,
            linkedin:false,
            email:false,
            site:false
        },
        industries:[],
        industry_value: null,

        specializations:[],
        specialization_value: null,

        tags:[],
        suggestions:[],

        fea_tags:[],
        fea_suggestions:[],

        facebook: "",
        twitter: "",
        linkedin: "",
        email: "",
        site:"",

        checked:false,
        active:true,

        videos:[],
        deletedData:[],
        shortLength:0
    };

    @autobind
    createNewItem() {
        return {
            v_name:""
        };
    }


    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.getIndustry();
        this.getKeyword();
        this.getFeature();
        this.props.onRef(this);
    }

    @autobind
    getIndustry(){
        http.get(`/industries/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    industries: data,
                });
            });
    }

    @autobind
    getKeyword(){
        http.get(`/keywords/all`)
            .then(response => response.json())
            .then((data) => {
                let suggestions = [];
                data.map((e, i) => {
                    suggestions.push({id: e.k_name, text: e.k_name})
                })
                this.setState({
                    suggestions:suggestions
                });
            });
    }

    @autobind
    getFeature(){
        http.get(`/features/all`)
            .then(response => response.json())
            .then((data) => {
                let fea_suggestions = [];
                data.map((e, i) => {
                    fea_suggestions.push({id: e.f_name, text: e.f_name})
                })
                this.setState({
                    fea_suggestions:fea_suggestions
                });
            });
    }


    @autobind
    addTool(event) {
        event.preventDefault();

        const {
            title,
            industry_value,
            specialization_value,
            description,
            text,
            image,
            tags,
            facebook,
            twitter,
            linkedin,
            email,
            site,
            fea_tags,
            checked,
            videos,
            valid,
            buttonName,
            prisingButton,
            active
        } = this.state;

        if (!valid.specialization_value || !valid.industry_value || !valid.title || !valid.description ||  !valid.text || !valid.image || !valid.tags) {
            const list = [];

            !valid.industry_value && list.push("Tool industry");
            !valid.specialization_value && list.push("Tool specialization");
            !valid.title && list.push("Tool title");
            !valid.description && list.push("Tool description");
            !valid.text && list.push("Tool text");
            !valid.image && list.push("Tool image");
            !valid.tags && list.push("Tool keyword");

            const message = 'Please fill following fields: ' + list.join(',');
            swal.fire('Failed', message, 'error');

            return;
        }

        const formData = new FormData();
        formData.append("industries", industry_value.value);
        formData.append("specializations", JSON.stringify(specialization_value));
        formData.append("t_title", title);
        formData.append("t_description", description);
        formData.append("t_text", text);
        formData.append("t_image", image[0] ? image[0].file : null);
        formData.append("keywords", JSON.stringify(tags));
        formData.append("t_facebook", facebook);
        formData.append("t_twitter", twitter);
        formData.append("t_linkedin", linkedin);
        formData.append("t_email", email);
        formData.append("t_site", site);
        formData.append("features", JSON.stringify(fea_tags));
        formData.append("t_featured", JSON.stringify(checked));
        formData.append("t_active", JSON.stringify(active));
        formData.append("videos", JSON.stringify(videos));
        formData.append("t_button_name", buttonName);
        formData.append("t_prising_button", prisingButton);

        http.withFormData("POST", '/tools/add', formData)
            .then((response: any) => {
                if (response.ok) {
                    swal.fire('Done', 'Partner successfully added.', 'success')
                        .then(() => {
                            this.setState({
                                updated: true,
                            });
                        });
                } else {
                    swal.fire('Failed', 'Something went wrong.', 'error');
                }
            })
            .catch((err) => {
                swal.fire('Failed', 'Something went wrong.', 'error');
            });
    }

    @autobind
    handleChangeIndustry(industry_value) {
        var { valid } = this.state;
        if(industry_value !== null) {
            http.get(`/industries/getById/${industry_value.value}`)
                .then(response => response.json())
                .then((data) => {
                    valid.industry_value = true;
                    this.setState({
                        specializations: data.specializations,
                        industry_value,
                        specialization_value: null,
                        valid
                    });
                })
        }else {
            valid.industry_value = false;
            valid.specialization_value = false;
            this.setState({
                industry_value: null,
                specializations: [],
                specialization_value: null,
                valid
            });
        }
    }

    @autobind
    handleChangeSpecialization(specialization_value) {
        const { valid } = this.state;
        if (specialization_value == "") {
            valid.specialization_value = false;
        } else {
            valid.specialization_value = true;
        }
        this.setState({
            specialization_value,
            valid
        });
    }

    @autobind
    changeToolTitle(event) {
        const { valid } = this.state;
        const title = event.target.value;

        if (title == "") {
            valid.title = false;
        } else {
            valid.title = true;
        }

        this.setState({
            title,
            valid,
        });
    }

    @autobind
    changeToolButtonName(event) {
        const buttonName = event.target.value;
        this.setState({
            buttonName,
        });
    }

    @autobind
    changeToolPrisingButton(event) {
        const prisingButton = event.target.value;
        this.setState({
            prisingButton,
        });
    }

    @autobind
    changeToolDescription(event) {
        const { valid, shortLength } = this.state;
        const description = event.target.value;

        if (description == "") {
            valid.description = false;
        } else {
            valid.description = true;
        }

        this.setState({
            description,
            valid,
            shortLength:description.length
        });
    }

    @autobind
    handleEditorChange(event,editor){
        const { valid } = this.state;
        const text = editor.getContent();

        if (text == "") {
            valid.text = false;
        } else {
            valid.text = true;
        }

        this.setState({
            text,
            valid,
        });
    }

    @autobind
    changeImage(files) {
        const { valid } = this.state;
        if (files.length == 0) {
            valid.image = false;
        } else {
            valid.image = true;
        }

        this.setState({
            image: files,
            valid,
        });
    }

    @autobind
    handleDelete(i) {
        const { tags, valid } = this.state;

        if(tags.length <= 1){
            valid.tags = false;
        }

        this.setState({
            tags: this.state.tags.filter((tag, index) => index !== i),
            valid
        });
    }

    @autobind
    handleAddition(tag) {
        const { tags, suggestions, valid } = this.state;

        var fruits = [];
        suggestions.map((e, i) => {
            fruits.push(e.text)
        })
        var a = fruits.indexOf(tag.id);

        if(a == -1){
            http.post ('/keywords/add', {k_name: tag.text})
        }

        if (tag.length == 0) {
            valid.tags = false;
        } else {
            valid.tags = true;
        }

        this.setState({
            tags: [...tags, { id: tag.text, text: tag.text }],
            valid
        });

        this.getKeyword();
    }

    @autobind
    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags });
    }

    @autobind
    handleTagClick(index) {
        console.log('The tag at index ' + index + ' was clicked');
    }

    @autobind
    changeToolFacebook(event) {
        const { valid } = this.state;
        const facebook = event.target.value;

        if (facebook == "") {
            valid.facebook = false;
        } else {
            valid.facebook = true;
        }

        this.setState({
            facebook,
            valid,
        });
    }

    @autobind
    changeToolTwitter(event) {
        const { valid } = this.state;
        const twitter = event.target.value;

        if (twitter == "") {
            valid.twitter = false;
        } else {
            valid.twitter = true;
        }

        this.setState({
            twitter,
            valid,
        });
    }

    @autobind
    changeToolLinkedin(event) {
        const { valid } = this.state;
        const linkedin = event.target.value;

        if (linkedin == "") {
            valid.linkedin = false;
        } else {
            valid.linkedin = true;
        }

        this.setState({
            linkedin,
            valid,
        });
    }

    @autobind
    changeToolEmail(event) {
        const { valid } = this.state;
        const email = event.target.value;

        if (email == "") {
            valid.email = false;
        } else {
            valid.email = true;
        }

        this.setState({
            email,
            valid,
        });
    }

    @autobind
    changeToolSite(event) {
        const { valid } = this.state;
        const site = event.target.value;

        if (site == "") {
            valid.site = false;
        } else {
            valid.site = true;
        }

        this.setState({
            site,
            valid,
        });
    }

    @autobind
    handleFeatureDelete(i) {
        const { fea_tags, valid } = this.state;

        if(fea_tags.length <= 1){
            valid.fea_tags = false;
        }

        this.setState({
            fea_tags: this.state.fea_tags.filter((tag, index) => index !== i),
            valid
        });
    }

    @autobind
    handleFeatureAddition(tag) {
        const { fea_tags, fea_suggestions, valid } = this.state;

        var fruits = [];
        fea_suggestions.map((e, i) => {
            fruits.push(e.text)
        })
        var a = fruits.indexOf(tag.id);

        if(a == -1){
            http.post ('/features/add', {f_name: tag.text})
        }

        if (tag.length == 0) {
            valid.fea_tags = false;
        } else {
            valid.fea_tags = true;
        }

        this.setState({
            fea_tags: [...fea_tags, { id: tag.text, text: tag.text }],
            valid
        });

        this.getFeature();
    }

    @autobind
    handleFeatureDrag(tag, currPos, newPos) {
        const fea_tags = [...this.state.fea_tags];

        // mutate array
        fea_tags.splice(currPos, 1);
        fea_tags.splice(newPos, 0, tag);

        // re-render
        this.setState({ fea_tags });
    }

    @autobind
    handleFeatureTagClick(index) {
        console.log('The tag at index ' + index + ' was clicked');
    }

    @autobind
    handleCheck() {
        this.setState({checked: !this.state.checked});
    }

    @autobind
    handleActive() {
        this.setState({active: !this.state.active});
    }

    @autobind
    onNumberChange(event, i) {
        const { videos } = this.state;
        //const { industryId } = this.props.match.params;

        videos[i].v_name = event.target.value;
        //videos[i].industry = industryId;

        this.setNewState(videos);
    }

    @autobind
    removeItemFromList(event, i) {
        event.stopPropagation();

        const { videos, deletedData } = this.state;

        if (videos.length > 0) {
            var item = videos.splice(i, 1);
        }else{
            videos.push(this.createNewItem());
        }

        if(item[0]._id){
            deletedData.push(item[0]);
        }

        this.setState({
            deletedData
        });
        this.setNewState(videos);
    }

    @autobind
    addItemToList(event) {
        event.stopPropagation();

        const { videos } = this.state;
        videos.push(this.createNewItem());

        this.setNewState(videos);
    }

    @autobind
    setNewState(videos) {
        this.setState({
            videos,
        });

        //this.props.onChange(items);
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }


    @autobind
    handleInit() {
        //console.log('FilePond instance has initialised', this.pond);
    }

    render() {
        const {
            loading,
            industries,
            industry_value,
            specializations,
            specialization_value,
            title,
            description,
            text,
            image,
            updated,
            tags,
            suggestions,
            facebook,
            twitter,
            linkedin,
            email,
            fea_tags,
            fea_suggestions,
            checked,
            videos,
            buttonName,
            active,
            shortLength,
            site,
            prisingButton
        } = this.state;

        if (updated) {
            return <Redirect to={Route.toUrl("dashboard_tool_all")} />
        }

        return(
            <Container fluid>
                <Row>
                    <Col sm="12">
                        <h4 className="header-title m-t-0 m-b-20">Add tool!</h4>
                    </Col>
                </Row>
                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo"/></Col></Row></Container> :
                        <Fragment>
                            <Row>
                                <Col className="dashboard_add_style_block col-sm-offset-3 col-sm-6">
                                    <form onSubmit={this.addTool}>

                                        <Row>
                                            <Col className="col-sm-6 one_sel">
                                                <Label for="title" className="dashboard_forms_label">Industry<sup
                                                    className="my_sup_class">*</sup></Label>
                                                <Select
                                                    placeholder="Choose your industry"
                                                    closeMenuOnSelect={true}
                                                    isClearable={true}
                                                    components={makeAnimated()}
                                                    options={industries.map((e, i) => {
                                                        return {key: i, value: e._id, label: e.i_name}
                                                    })}
                                                    value={industry_value}
                                                    onChange={this.handleChangeIndustry}
                                                />
                                            </Col>
                                            <Col className="col-sm-6 tow_sel">
                                                <Label for="title" className="dashboard_forms_label">Specialization<sup
                                                    className="my_sup_class">*</sup></Label>
                                                <Select
                                                    placeholder="Choose your specialization"
                                                    closeMenuOnSelect={false}
                                                    components={makeAnimated()}
                                                    isMulti
                                                    options={specializations.map((e, i) => {
                                                        return {key: i, value: e._id, label: e.s_name}
                                                    })}
                                                    value={specialization_value}
                                                    onChange={this.handleChangeSpecialization}
                                                />
                                            </Col>
                                            <Col>
                                                <Row>
                                                    <Col className="col-xs-7">
                                                        <Label for="title" className="dashboard_forms_label">Tool name<sup
                                                            className="my_sup_class">*</sup></Label>
                                                        <Input
                                                            type="text" placeholder="Tool name"
                                                            className="contact_form_input" id="title"
                                                            value={title} onChange={this.changeToolTitle}
                                                        />
                                                    </Col>
                                                    <Col className="col-xs-2 text-center">
                                                        <Label for="title" className="dashboard_forms_label">Featured</Label>
                                                        <div>
                                                            <input
                                                                className="dashboard_featured_cachkbox"
                                                                type="checkbox"
                                                                onChange={this.handleCheck}
                                                                defaultChecked={checked}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col className="col-xs-3 text-center">
                                                        <Label for="title" className="dashboard_forms_label">Active-Inactive</Label>
                                                        <div>
                                                            <input
                                                                className="dashboard_featured_cachkbox"
                                                                type="checkbox"
                                                                onChange={this.handleActive}
                                                                defaultChecked={active}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <FormGroup className="mt-4">
                                                    <Label for="text" className="dashboard_forms_label">Short description<sup
                                                        className="my_sup_class">*</sup></Label>
                                                    <Input
                                                        type="textarea" placeholder="Short description"
                                                        className="contact_form_input" name="text" id="text"
                                                        value={description} onChange={this.changeToolDescription}
                                                        maxLength={70}
                                                    />
                                                    {
                                                        shortLength < 70 ?
                                                            <div className="dashboatd_shortLength_1">Count - {shortLength}</div>
                                                        :
                                                            <div className="dashboatd_shortLength_2">Count - {shortLength}</div>
                                                    }
                                                </FormGroup>
                                                <FormGroup className="mt-4">
                                                    <Label for="text" className="dashboard_forms_label">Long description<sup
                                                        className="my_sup_class">*</sup></Label>
                                                    <Editor
                                                        initialValue={text}
                                                        init={{
                                                            height: 300,
                                                            menubar: false,
                                                            plugins: [
                                                                'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons'
                                                            ],
                                                            toolbar:
                                                                'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl'
                                                        }}
                                                        onChange={this.handleEditorChange}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mt-4">
                                                    <Label for="image" className="dashboard_forms_label">Image<sup className="my_sup_class">*</sup></Label>
                                                    <FilePond
                                                        labelIdle={`<span class="filepond--label-action">Image</span>`}
                                                        files={image}
                                                        allowMultiple={false}
                                                        onupdatefiles={this.changeImage}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col className="dashboard_keyword_block">
                                                <Label for="title" className="dashboard_forms_label">Keywords<sup
                                                    className="my_sup_class">*</sup></Label>
                                                    <ReactTags
                                                        tags={tags}
                                                        suggestions={suggestions}
                                                        handleDelete={this.handleDelete}
                                                        handleAddition={this.handleAddition}
                                                        handleDrag={this.handleDrag}
                                                        handleTagClick={this.handleTagClick}
                                                        placeholder="Choose your keyword"
                                                    />
                                            </Col>
                                            <Col className="dashboard_keyword_block">
                                                <Label for="title" className="dashboard_forms_label">Features</Label>
                                                <ReactTags
                                                    tags={fea_tags}
                                                    suggestions={fea_suggestions}
                                                    handleDelete={this.handleFeatureDelete}
                                                    handleAddition={this.handleFeatureAddition}
                                                    handleDrag={this.handleFeatureDrag}
                                                    handleTagClick={this.handleFeatureTagClick}
                                                    placeholder="Choose your feature"
                                                />
                                            </Col>
                                            <Col>
                                                <FormGroup className="mt-4">
                                                    <Label for="facebook" className="dashboard_forms_label">Facebook</Label>
                                                    <Input
                                                        type="text" placeholder="Facebook"
                                                        className="contact_form_input" id="facebook"
                                                        value={facebook} onChange={this.changeToolFacebook}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mt-4">
                                                    <Label for="twitter" className="dashboard_forms_label">Twitter</Label>
                                                    <Input
                                                        type="text" placeholder="Twitter"
                                                        className="contact_form_input" id="twitter"
                                                        value={twitter} onChange={this.changeToolTwitter}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mt-4">
                                                    <Label for="linkedin" className="dashboard_forms_label">Linkedin</Label>
                                                    <Input
                                                        type="text" placeholder="Linkedin"
                                                        className="contact_form_input" id="linkedin"
                                                        value={linkedin} onChange={this.changeToolLinkedin}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mt-4">
                                                    <Label for="site" className="dashboard_forms_label">Web site</Label>
                                                    <Input
                                                        type="text" placeholder="Web site"
                                                        className="contact_form_input" id="site"
                                                        value={site} onChange={this.changeToolSite}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mt-4">
                                                    <Label for="email" className="dashboard_forms_label">Email</Label>
                                                    <Input
                                                        type="text" placeholder="Email"
                                                        className="contact_form_input" id="email"
                                                        value={email} onChange={this.changeToolEmail}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <Label for="buttonName" className="dashboard_forms_label">Button name</Label>
                                                <Input
                                                    type="text" placeholder="Button name"
                                                    className="contact_form_input" id="buttonName"
                                                    value={buttonName} onChange={this.changeToolButtonName}
                                                />
                                            </Col>
                                            <Col>
                                                <Label for="prisingButton" className="dashboard_forms_label">Prising URL</Label>
                                                <Input
                                                    type="text" placeholder="Prising URL"
                                                    className="contact_form_input" id="prisingButton"
                                                    value={prisingButton} onChange={this.changeToolPrisingButton}
                                                />
                                            </Col>
                                            <Col>
                                                <FormGroup className="mt-4">
                                                    <Label for="name" className="dashboard_forms_label">Videos ID</Label>
                                                    {videos.map((item, i) => (
                                                        <div className="row" key={i}>
                                                            <div className="col-sm-12 specialization_item_input">
                                                                <div className="col-sm-11">
                                                                    <Input value={item.v_name} onChange={(e) => this.onNumberChange(e, i)} id="carNumber"/>
                                                                </div>
                                                                <div className="col-sm-1">
                                                                    <Button size="sm" color="danger" className="specialization_remove_link" onClick={(e) => this.removeItemFromList(e, i)}>
                                                                        <i className="fa fa-times" />
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                    <div className="row">
                                                        <div className="col-sm-12 text-right">
                                                            <Button size="sm" color="primary" className="specialization_add_item_link" onClick={this.addItemToList}>
                                                                <i className="fa fa-plus" />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <div className="text-center dashboard_tool_add_form_button">
                                            <Button className="dashboard_add_form_button">Add</Button>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Fragment>
                }
            </Container>
        );

    }
}
